/* Cocoony · Savon kaki : regalos en vraies lignes du panier.
   Règle (source) : 2 barras = jabonera ; 4 = + bolsa ; 8 = + lata. Une seule unité par regalo.
   Les regalos sont des produits dédiés (vrai prix) rendus gratuits par une remise automatique 100 %.
   Ce script : ajoute le pack depuis la PDP (regalos d'abord, jabón en dernier pour qu'il s'affiche en haut),
   puis réconcilie le panier après toute modification (quantité, suppression) sur toutes les pages. */
(function () {
  if (window.CocoonyKaki) return;
  var SOAP = 55584433766741;
  var GIFTS = [
    { id: 55584434159957, min: 2 },
    { id: 55584434225493, min: 4 },
    { id: 55584434487637, min: 8 }
  ];
  var ADDONS = { 55585920516437: 2, 55585920745813: 4, 55585920876885: 8 };
  var SECTIONS = 'cart-drawer,cart-icon-bubble';
  var nativeFetch = window.fetch.bind(window);
  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function post(url, body) {
    return nativeFetch(root() + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) { var e = new Error(j.description || j.message || 'Error'); e.data = j; throw e; } return j; }); });
  }
  function getCart() { return nativeFetch(root() + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function soapQty(cart) { var q = 0; cart.items.forEach(function (i) { if (i.variant_id === SOAP) q += i.quantity; }); return q; }
  function isGift(id) { for (var k = 0; k < GIFTS.length; k++) if (GIFTS[k].id === id) return true; return false; }
  function plan(cart, extra) {
    var q = soapQty(cart) + (extra || 0), want = {}, seen = {}, updates = {}, add = [], n = 0;
    GIFTS.forEach(function (g) { want[g.id] = q >= g.min ? 1 : 0; });
    cart.items.forEach(function (i) {
      if (ADDONS[i.variant_id] && q >= ADDONS[i.variant_id]) { updates[i.key] = 0; n++; return; }
      if (!isGift(i.variant_id)) return;
      var w = seen[i.variant_id] ? 0 : want[i.variant_id];
      seen[i.variant_id] = true;
      if (i.quantity !== w) { updates[i.key] = w; n++; }
    });
    GIFTS.forEach(function (g) { if (want[g.id] && !seen[g.id]) add.push({ id: g.id, quantity: 1 }); });
    return { updates: updates, add: add, changed: n > 0 || add.length > 0 };
  }
  function drawer() { return document.querySelector('cart-drawer'); }
  function renderSilently(state) {
    if (!state || !state.sections) return;
    var d = drawer();
    var parse = function (html, sel) { var el = new DOMParser().parseFromString(html, 'text/html').querySelector(sel); return el ? el.innerHTML : null; };
    if (state.sections['cart-drawer']) {
      var target = document.getElementById('CartDrawer'), html = parse(state.sections['cart-drawer'], '#CartDrawer');
      if (target && html !== null) target.innerHTML = html;
      if (d) {
        var empty = !state.item_count && state.items && state.items.length === 0;
        d.classList.toggle('is-empty', !!empty);
        var ov = d.querySelector('#CartDrawer-Overlay');
        if (ov && d.close) ov.addEventListener('click', d.close.bind(d));
      }
    }
    if (state.sections['cart-icon-bubble']) {
      var bub = document.getElementById('cart-icon-bubble'), h2 = parse(state.sections['cart-icon-bubble'], '.shopify-section');
      if (bub && h2 !== null) bub.innerHTML = h2;
    }
  }
  var running = null, queued = false;
  /* Réconcilie ; renvoie l'état final avec sections si quelque chose a changé, sinon null. */
  function reconcile() {
    if (running) { queued = true; return running; }
    running = getCart().then(function (cart) {
      var p = plan(cart, 0);
      if (!p.changed) return null;
      var chain = Promise.resolve(null);
      if (Object.keys(p.updates).length) chain = chain.then(function () { return post('cart/update.js', { updates: p.updates, sections: SECTIONS, sections_url: location.pathname }); });
      if (p.add.length) chain = chain.then(function () { return post('cart/add.js', { items: p.add, sections: SECTIONS, sections_url: location.pathname }); }).then(function () { return post('cart/update.js', { updates: {}, sections: SECTIONS, sections_url: location.pathname }); });
      return chain;
    }).catch(function (e) { if (window.console) console.warn('[cocoony-kaki] reconcile', e); return null; })
      .then(function (state) {
        running = null;
        if (state) {
          if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return state; }
          renderSilently(state);
          document.dispatchEvent(new CustomEvent('cocoony-kaki:cart', { detail: state }));
        }
        if (queued) { queued = false; return reconcile(); }
        return state;
      });
    return running;
  }
  /* Ajout depuis la PDP : regalos manquants d'abord, puis le jabón (il s'affiche en haut du panier). */
  function addPack(qty) {
    qty = parseInt(qty, 10) || 1;
    return getCart().then(function (cart) {
      var p = plan(cart, qty), items = p.add.slice();
      items.push({ id: SOAP, quantity: qty });
      return post('cart/add.js', { items: items, sections: SECTIONS, sections_url: location.pathname });
    }).then(function (added) {
      return reconcile().then(function (state) {
        if (state) return state;
        return post('cart/update.js', { updates: {}, sections: SECTIONS, sections_url: location.pathname }).then(function (s) { s.id = SOAP; return s; }).catch(function () { return added; });
      });
    });
  }
  /* Après chaque requête panier du thème (quantité, suppression, ajout), réconcilier. */
  var timer;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch(input, init);
    if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      p.then(function () { clearTimeout(timer); timer = setTimeout(reconcile, 350); }, function () {});
    }
    return p;
  };
  window.CocoonyKaki = { addPack: addPack, reconcile: reconcile, soap: SOAP, gifts: GIFTS, open: function (state) { var d = drawer(); if (d && d.renderContents && state && state.sections) { if (state.item_count || (state.items && state.items.length)) d.classList.remove('is-empty'); d.renderContents(state); return true; } return false; } };
  /* Tiroir : ajoute l'accessoire payant au panier. */
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('[data-ck-add]');
    if (!b) return;
    ev.preventDefault();
    b.disabled = true;
    post('cart/add.js', { items: [{ id: parseInt(b.getAttribute('data-ck-add'), 10), quantity: 1 }], sections: SECTIONS, sections_url: location.pathname })
      .then(function (added) { return post('cart/update.js', { updates: {}, sections: SECTIONS, sections_url: location.pathname }).catch(function () { return added; }); })
      .then(renderSilently)
      .catch(function (e) { b.disabled = false; if (window.console) console.warn('[cocoony-kaki] add', e); });
  });
  /* Au chargement : seulement si le panier n'est pas vide (pastille du thème) ou sur la PDP, pour ne pas ajouter de requête aux autres visites. */
  function boot() { if (document.querySelector('.cart-count-bubble') || document.querySelector('[data-rcq-main]')) reconcile(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
